'use client'
import { NotificationVariant } from '../../../../types'
import { InfoErrorIcon, InfoIcon, InfoSuccessIcon, InfoWarningIcon } from '../../../icons'
import React, { ReactNode } from 'react'

export const getNotificationIcon = (variant: NotificationVariant, customIcon?: ReactNode): ReactNode => {
    switch (variant) {
        case NotificationVariant.ERROR:
            return <InfoErrorIcon />
        case NotificationVariant.WARNING:
            return <InfoWarningIcon />
        case NotificationVariant.SUCCESS:
            return <InfoSuccessIcon />
        default:
            return customIcon || <InfoIcon />
    }
}
